import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Scrollable from '@xanadu/ui-shared/components/widgets/Scrollable';

import IconLeft from '../../../../images/icons/misc/left.svg';

import styles from './Panel.module.scss';

const Panel = ({
  onBack,
  title,
  className,
  children
}) => {
  const mainClass = classNames({
    [styles.panel]: true,
    [className]: Boolean(className)
  });

  return (
    <div className={mainClass}>
      <div className={styles.header}>
        <a
          role="button"
          className={styles.buttonGoBack}
          onClick={(e) => {
            e.preventDefault();
            onBack();
          }}
        >
          {
            <IconLeft
              className={styles.icon}
            />
          }
          {title}
        </a>
      </div>
      <div className={styles.content}>
        <Scrollable>
          {children}
        </Scrollable>
      </div>
    </div>
  );
};

Panel.propTypes = {
  onBack: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default Panel;
